import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { courierApi } from '@/services/api'
import type { Delivery } from '@/types'

export function useDeliveries(status?: string) {
  return useQuery<Delivery[]>({
    queryKey: ['deliveries', status],
    queryFn: () => courierApi.getDeliveries(status),
    refetchInterval: 5000, // Poll every 5 seconds
  })
}

export function useDelivery(orderId: string) {
  const { data: deliveries } = useDeliveries()
  return deliveries?.find((d) => d.orderId === orderId)
}

export function usePickupOrder() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ orderId, notes }: { orderId: string; notes?: string }) =>
      courierApi.pickupOrder(orderId, notes),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['deliveries'] })
    },
  })
}

export function useDeliverOrder() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      orderId,
      proofOfDelivery,
      notes,
    }: {
      orderId: string
      proofOfDelivery?: string
      notes?: string
    }) => courierApi.deliverOrder(orderId, proofOfDelivery, notes),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['deliveries'] })
    },
  })
}
